import React from "react";
import {
  Box,
  Container,
  Row,
  Column,
  FooterLink,
  Heading,
} from "./FooterStyles";

const Footer = () => {
  return (
    <Box>
      <Container>
        <Row>
          <Column>
            <Heading>Company</Heading>
            <FooterLink href="#why-svik">Donate</FooterLink>
            <FooterLink href="#">About</FooterLink>
          </Column>
          {/* <Column>
            <Heading>Download</Heading>
            <FooterLink href="#">Android</FooterLink>
            <FooterLink href="#">Developers</FooterLink>
          </Column> */}
          <Column>
            <Heading href="#">Social</Heading>
            <FooterLink href="https://www.github.com/saffron-codes/svik">Github</FooterLink>
            <FooterLink href="https://www.instagram.com/svik_app/">Instagram</FooterLink>
          </Column>
          <Column>
            <Heading href="#">Help</Heading>
            <FooterLink href="#">Support</FooterLink>
            <FooterLink href="#">Community</FooterLink>
          </Column>
        </Row>
      </Container>
    </Box>
  );
};
export default Footer;